import { render, staticRenderFns } from "./Organisation.vue?vue&type=template&id=66fa0124&scoped=true"
import script from "./Organisation.vue?vue&type=script&lang=js"
export * from "./Organisation.vue?vue&type=script&lang=js"
import style0 from "./Organisation.vue?vue&type=style&index=0&id=66fa0124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fa0124",
  null
  
)

export default component.exports